import React from 'react';
import { Container } from 'react-bootstrap';
import { Link as ReactScrollLink } from 'react-scroll';
import { Link as GatsbyLink } from 'gatsby';
import { useLocation } from '@reach/router';
import { useConsentUi } from './ConsentContext';
import { isHomePath, localeHomePath, localePath } from '../utils/languages';
import ChevronUp from '../svg/ChevronUp';

const Footer = ({ translate }) => {
  const { openCookieSettings } = useConsentUi();
  const location = useLocation();
  const pathname = location?.pathname || '';
  const isHomePage = isHomePath(pathname);
  const home = localeHomePath(pathname);

  return (
    <footer className="footer navbar-static-bottom">
      <Container>
        {isHomePage && (
          <ReactScrollLink
            to="main"
            smooth
            duration={500}
            className="back-to-top"
            role="button"
            tabIndex={0}
            aria-label="Back to top"
          >
            <ChevronUp width="28" height="28" />
          </ReactScrollLink>
        )}
        <hr />
        <p className="footer__text py-1">{translate.about.legalP1}</p>
        <p className="footer__text py-1">
          <GatsbyLink to={localePath(pathname, 'how-it-works')}>{translate.nav.howItWorks}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to="/guides/">{translate.nav.guides}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to="/blog/">{translate.nav.blog}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to={localePath(pathname, 'faq')}>{translate.nav.faq}</GatsbyLink>
        </p>
        <p className="footer__text py-1">
          <GatsbyLink to={home}>{translate.nav.home}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to={localePath(pathname, 'about')}>{translate.about.aboutLink}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to={localePath(pathname, 'contact')}>{translate.about.contactLink}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to={localePath(pathname, 'privacy')}>{translate.about.privacyLink}</GatsbyLink>
          <span className="mx-4">·</span>
          <GatsbyLink to={localePath(pathname, 'terms')}>{translate.about.termsLink}</GatsbyLink>
          <span className="mx-4">·</span>
          <button type="button" className="footer__cookie-settings" onClick={openCookieSettings}>
            {translate.cookie.cookieSettings}
          </button>
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
